<template>
  <div class="breadcrumbs">
    ZONE - <span style="font-weight: bold; color: #202f64;">Budynki</span>
  </div>
</template>

<script>
export default {
  name: "Breadcrumps"
}
</script>

<style scoped>
.breadcrumbs {
  color: #6d6d6d;
  width: 100%;
  height: 7rem;
  padding: 2.5rem 2.4rem;
  font-size: 1.6rem;
}
</style>
